import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0eb7828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weight_work" }
const _hoisted_2 = { class: "drawer_wrap" }
const _hoisted_3 = { class: "drawer_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "权重管理", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "cont_list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cont_list_head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cont_list_head_rol1" }, "分类"),
  /*#__PURE__*/_createElementVNode("div", { class: "cont_list_head_rol2" }, "权重"),
  /*#__PURE__*/_createElementVNode("div", { class: "cont_list_head_rol3" }, "操作")
], -1))
const _hoisted_8 = { class: "cont_list_work" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "drawer_footer" }
const _hoisted_11 = { class: "btn_group" }

import { ref, unref, reactive } from 'vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Weight',
  props: {
    dataSource: null
  },
  emits: ['click:callbackSecPage', 'click:updataList'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };



const onBlack = () => {
  emit('click:callbackSecPage');
};
const onSave = () => {
  try {
    list.value.forEach((e) => {
      if (e.key === '' || e.value === '') {
        throw '输入框不能为空！';
      }
    });
    emit('click:updataList', list.value);
    onBlack();
  } catch (err: any) {
    message.error(err);
  }
};

const list = ref<any[]>([]);
list.value = JSON.parse(JSON.stringify(unref(props.dataSource)));
const addWeight = () => {
  list.value.push({
    key: '',
    value: '',
  });
};

const getRolClass = (index: number) => {
  return 'cont_list_head_rol' + index;
};

const delModal = reactive<RootModal>({
  title: '删除',
  visible: false,
  loading: false,
});
const listIndex = ref();
const openDelModal = (index: number) => {
  delModal.visible = true;
  listIndex.value = index;
};

const close = () => {
  list.value.splice(listIndex.value, 1);
  delModal.visible = false;
  listIndex.value = undefined;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_a_button, {
          type: "link",
          class: "drawer_title_back",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回>>")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "cont_list_row",
                key: index
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([getRolClass(1)])
                }, [
                  _createVNode(_component_a_input, {
                    value: item.key,
                    "onUpdate:value": ($event: any) => ((item.key) = $event),
                    placeholder: "请输入分类"
                  }, null, 8, ["value", "onUpdate:value"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([getRolClass(2)])
                }, [
                  _createVNode(_component_a_input, {
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    placeholder: "请输入权重"
                  }, null, 8, ["value", "onUpdate:value"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([getRolClass(3)]),
                  onClick: ($event: any) => (openDelModal(index))
                }, [
                  _createVNode(_component_svg_icon, { "icon-class": "unionDel" })
                ], 10, _hoisted_9)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "cont_list_foot",
            onClick: addWeight
          }, "+ 添加类别")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn",
            onClick: onBlack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            class: "mod_modal_btn mod_type_primary",
            onClick: onSave
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        ok: close,
        close: () => (delModal.visible = false)
      }, null, 8, ["visible", "close"])
    ])
  ]))
}
}

})